<template lang="html">
  <Form ref="form" :model="form">
    <h2 style="margin: 1rem 1rem 2rem">Movimento contabile in partita doppia</h2>
    <FormItem prop="category" :rules="req" label="Descrizione" :label-width="120">
      <AutoComplete
          v-model="form.category"
          :data="[]"
          :filter-method="autofilter"
          placeholder="Descrizione"
          icon="ios-pricetags">
      </AutoComplete>
    </FormItem>
    <!-- <FormItem label="Causale" :label-width="120">
      <AutoComplete
          v-model="form.causal"
          :data="filters.causals"
          :filter-method="autofilter"
          placeholder="Causale"
          icon="ios-pricetags">
      </AutoComplete>
    </FormItem> -->
    <FormItem prop="date" :rules="req" label="Data operazione" :label-width="120">
      <LocalDate v-model="form.date"/>
    </FormItem>

    <table class="my-table">
      <thead>
        <tr>
          <th style="width: 10px"></th>
          <th >Conto</th>
          <th style="width: 20%">Dare</th>
          <th style="width: 20%">Avere</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(line, i) in form.lines" :key="line.id">
          <td>
            <Button type="error" size="small" shape="circle" style="margin-top: 6px" @click="form.lines.splice(i, 1)">
              <Icon type="ios-trash"/>
            </Button>
          </td>
          <td>
            <FormItem :prop="'lines.' + i + '.ledger_id'" :rules="req">
              <LedgerSelect v-model="line.ledger_id" :ledgers="ledgers"/>
            </FormItem>
          </td>
          <td>
            <FormItem :rules="req">
              <NumInput right :step="0.01" :value.once="line.amount > 0 ? line.amount : 0" @input="line.amount = $event" :disabled="line.amount < 0"/>
            </FormItem>
          </td>
          <td>
            <FormItem :rules="req">
              <NumInput right :step="0.01" :value.once="line.amount < 0 ? -line.amount : 0" @input="line.amount = -$event" :disabled="line.amount > 0"/>
            </FormItem>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="sum" class="fg-error">
      La somma delle operazioni deve essere zero (adesso è {{ sum.toFixed(2) }})
    </div>
    <br>
    <Button @click="addLine()">Aggiungi linea</Button>
    &nbsp;
    <div style="float: right">
      <Button @click="$emit('close')" type="error">Annulla</Button>
      &nbsp;
      <Button @click="submit" type="primary">Salva</Button>
    </div>
  </Form>
</template>

<script>
export default {
  props: ['tx', 'filters'],
  data () {
    return {
      ledgers: null,
      form: this.tx && this.tx.id ? this._.cloneDeep(this.tx) : {
        date: (new Date()).serializeLocal(),
        lines: [],
        company_id: this.$store.company.id,
      },
      line_rules: {
        amount: {
          required: true,
          message: 'Compilare il campo'
        },
        ledger_id: {
          required: true,
        }
      }
    }
  },
  mounted() {
    while (this.form.lines.length < 2) this.addLine()
    this.$http.get('ledgers?company_id='+this.$store.company.id).then(res => {
      this.ledgers = res.data
    })
  },
  computed: {
    sum() {
      var sum = 0
      this.form.lines.forEach(l => sum+= l.amount)
      return Math.round(sum*100)/100
    }
  },
  methods: {
    submit() {
      console.log('form')
      this.$refs.form.validate(valid => {
        console.log('form', valid)
        if (!valid) {
          return this.$Message.error('Controllare i campi')
        }
        if (this.sum) {
          return this.$Message.error('La somma delle operazioni deve essere zero')
        }

        this.loading = true
        this.$http.post('transactions', this.form).then(res => {
          this.$emit('close')
          this.$emit('saved', res.data)
        }).finally(res => {this.loading = false})
      })
    },
    addLine() {
      this.form.lines.push({
        ledger_id: null,
        amount: 0,
      })
    }
  }
}
</script>

<style lang="css">
</style>
